
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,

  getTools: (state) => state.tools,
}